import axios from 'axios';
import router from './router';
const SERVER = process.env.VUE_APP_API_URL;

export default {
  getMember: async () => {
    return handleResponse(
      axios(SERVER + '/members',
            {withCredentials: true}))
  },

  updateMemberPhoneNumber: async (phoneNumber) => {
    return handleResponse(
      axios.post(
        SERVER + '/members/phone-number',
        {phoneNumber},
        {withCredentials: true}));
  },

  updateMemberTz: async (tzid) => {
    return handleResponse(
      axios.post(
        SERVER + '/members/set-zone',
        {tzid},
        {withCredentials: true}));
  },

  updateMemberPrefReactionGroup: async (pref) => {
    return handleResponse(
      axios.post(
        SERVER + '/members/pref/reaction-group',
        {pref},
        {withCredentials: true}));
  },

  updateMemberHandle: async (handle) => {
    return handleResponse(
      axios.post(
        SERVER + '/members/handle',
        {handle},
        {withCredentials: true}));
  },

  updateMemberPrefs: async (prefs) => {
    return handleResponse(
      axios.post(
        SERVER + '/members/prefs',
        {prefs},
        {withCredentials: true}));
  },

  resendMemberEmailVerification: async () => {
    return handleResponse(
      axios.post(
        SERVER + '/members/email/resend-verification',
        {},
        {withCredentials: true}));
  },

  resendMemberNumberVerification: async () => {
    return handleResponse(
      axios.post(
        SERVER + '/members/number/resend-verification',
        {},
        {withCredentials: true}));
  },

  verifyMemberEmail: async (token) => {
    return handleResponse(
      axios.post(
        SERVER + '/members/email/verify',
        {token},
        {withCredentials: true}));
  },

  verifyMemberNumber: async (token) => {
    return handleResponse(
      axios.post(
        SERVER + '/members/number/verify',
        {token},
        {withCredentials: true}));
  },

  logIn: async (username, password) => {
    return handleResponse(axios.post(SERVER + '/login', {
      username,
      password
    }, {withCredentials:true}))
  },

  signup: async (username, password) => {
    return handleResponse(axios.post(SERVER + '/signup', {
      username,
      password,
    }, {withCredentials:true}))
  },

  logOut: async (number, pw) => {
    return handleResponse(axios.post(SERVER + '/logout', {}, {
      withCredentials: true
    }))
  },

  getRecords: async (type, path, todo, tags, start, end, page = 0) => {
    return (await handleResponse(
      axios.post(
        SERVER + '/messages/list',
        {
          tags,
          todo,
          path,
          start,
          end,
          page,
          type
        },
        {
          withCredentials: true,
    })))
  },

  getRecentRecords: async () => {
    return (await handleResponse(
      axios.get(
        SERVER + '/messages/recent-records',
        {
          withCredentials: true,
    })))
  },

  searchRecords: async (query, page = 0) => {
    return (await handleResponse(
      axios.post(
        SERVER + '/messages/search',
        {
          query,
          page
        },
        {
          withCredentials: true,
    })))
  },

  exportRecords: async () => {
    return (await handleResponse(
      axios.get(
        SERVER + '/messages/export',
        {
          withCredentials: true,
    })))
  },

  uploadFile: async (file) => {
    const formData = new FormData();
    formData.append('f', file);

    return (await handleResponse(
      axios.post(
        SERVER + '/messages/upload',
        formData,
        {
          withCredentials: true,
          headers: {
            'Content-Type': 'multipart/form-data'
          }
    })))
  },

  addRecord: async (raw, isPublic) => {
    return (await handleResponse(
      axios.post(
        SERVER + '/messages/go',
        {
          raw,
          isPublic
        },
        {
          withCredentials: true
    })))
  },

  bulkAddRecords: async (notes, type) => {
    return (await handleResponse(
      axios.post(
        SERVER + '/messages/import',
        {
          notes,
          type
        },
        {
          withCredentials: true,
    })))
  },

  getImports: async () => {
    return (await handleResponse(
      axios.get(
        SERVER + '/messages/imports',
        {
          withCredentials: true,
    })))
  },

  getImport: async (shortId) => {
    return (await handleResponse(
      axios.get(
        SERVER + '/messages/imports/' + shortId,
        {
          withCredentials: true
    })))
  },

  getImportRecords: async (shortId) => {
    return (await handleResponse(
      axios.get(
        SERVER + '/messages/imports/' + shortId + '/records',
        {
          withCredentials: true,
          transformResponse: (res) => {
            // NOTE: this response can be super large so don't parse as json just yet
            return res;
          },
    })))
  },

  deleteImport: async (shortId) => {
    return (await handleResponse(
      axios.delete(
        SERVER + '/messages/imports/' + shortId,
        {
          withCredentials: true,
    })))
  },



  createExport: async (type, params) => {
    return (await handleResponse(
      axios.post(
        SERVER + '/exports',
        {
          type,
          params
        },
        {
          withCredentials: true,
    })))
  },

  getExports: async () => {
    return (await handleResponse(
      axios.get(
        SERVER + '/exports',
        {
          withCredentials: true,
    })))
  },

  getExport: async (shortId) => {
    return (await handleResponse(
      axios.get(
        SERVER + '/exports/' + shortId,
        {
          withCredentials: true
    })))
  },


  deleteExport: async (shortId) => {
    return (await handleResponse(
      axios.delete(
        SERVER + '/exports/' + shortId,
        {
          withCredentials: true,
    })))
  },

  updateMessage: async (id, body, path, date, isPublic) => {
    return (await handleResponse(
      axios.post(SERVER + '/messages/' + id,
                 {
                   body, path, date, isPublic
                 },
                 {
                   withCredentials: true,
    })))
  },

  updateMessageDate: async (id, date) => {
    return (await handleResponse(
      axios.post(SERVER + '/messages/' + id + '/date',
                 {
                   date
                 },
                 {
                   withCredentials: true,
                 })))
  },

  deleteMessage: async (id) => {
    return (await handleResponse(
      axios.delete(SERVER + '/messages/' + id,
                   {
                     withCredentials: true,
    })))
  },

  getElements: async () => {
    return (await handleResponse(
      axios(SERVER + '/messages/elements',
            {withCredentials: true}))).res
  },

  getPaths: async () => {
    return (await handleResponse(
      axios(SERVER + '/messages/paths',
            {withCredentials: true}))).res
  },

  getTags: async () => {
    return (await handleResponse(
      axios(SERVER + '/messages/tags',
            {withCredentials: true}))).res
  },

  getDates: async () => {
    return (await handleResponse(
      axios(SERVER + '/messages/dates',
            {withCredentials: true}))).res
  },

  getBangs: async (path, tags, date, mode) => {
    return (await handleResponse(
      axios.post(SERVER + '/messages/bangs',
                 {
                   path, tags, date, mode
                 },
                 {
                   withCredentials: true
                 }
    ))).res
  },

  getTotals: async (path, tags, date, mode) => {
    return (await handleResponse(
      axios.post(SERVER + '/messages/totals',
                 {
                   path,
                   tags,
                   tzid: Intl.DateTimeFormat().resolvedOptions().timeZone
                 },
                 {
                   withCredentials: true
                 }
    ))).res
  },

  createPig: async (pig) => {
    return (await handleResponse(
      axios.post(SERVER + '/prompts',
                 pig,
                 {
                   withCredentials: true
    })))
  },

  editPig: async (id, pig) => {
    return (await handleResponse(
      axios.post(SERVER + '/prompts/' + id,
                 pig,
                 {
                   withCredentials: true
    })))
  },



  deletePig: async (id) => {
    return (await handleResponse(
      axios.delete(SERVER + '/prompts/' + id,
                   {
                     withCredentials: true
    })))
  },



  createApi: async (api) => {
    return (await handleResponse(
      axios.post(SERVER + '/spells/api',
                 api,
                 {
                   withCredentials: true
                 }
    )))
  },

  editApi: async (id, api) => {
    return (await handleResponse(
      axios.post(SERVER + '/spells/api/' + id,
                 api,
                 {
                   withCredentials: true
                 }
    )))
  },


  deleteApi: async (id) => {
    return (await handleResponse(
      axios.delete(SERVER + '/spells/api/' + id,
                 {
                   withCredentials: true
                 }
    )))
  },

  getPigs: async () => {
    return (await handleResponse(
      axios(SERVER + '/prompts',
            {
              withCredentials: true
            })))
  },


  upgradeSub: async (token, plan, promo) => {
    return (await handleResponse(
      axios.post(
        SERVER + '/co/subscribe',
        {token, plan, promo},
        {withCredentials: true})))
  },

  downgradeSub: async (subscriptionId) => {
    return (await handleResponse(
      axios.post(
        SERVER + '/co/unsubscribe',
        {subscriptionId},
        {withCredentials: true})))
  },

  forgot: async (username) => {
    return handleResponse(
      axios.post(
        SERVER + '/forgot',
        {username},
        {withCredentials: true}))
  },

  resetPw: async (newPassword, token) => {
    return handleResponse(
      axios.post(
        SERVER + '/reset/' + token,
        {newPassword},
        {withCredentials: true}));
  },

  getMemberByToken: async (token, newPassword) => {
    return handleResponse(
      axios(
        SERVER + '/reset/' + token,
        {withCredentials: true}));
  },

  getConnections: async () => {
    return handleResponse(
      axios(
        SERVER + '/msg/connections',
        {withCredentials: true}));
  },

  getVerifiedConnections: async () => {
    return handleResponse(
      axios(
        SERVER + '/msg/connections/verified',
        {withCredentials: true}));
  },

  addConnection: async (type, target) => {
    return handleResponse(
      axios.post(
        `${SERVER}/msg/connections`,
        {type, target},
        {withCredentials: true}));
  },

  verifyConnection: async (connectionId, code) => {
    return handleResponse(
      axios.post(
        `${SERVER}/msg/connections/${connectionId}/verify`,
        {code},
        {withCredentials: true}));
  },

  verifyTelegramConnection: async (verificationCode) => {
    return handleResponse(
      axios.post(
        `${SERVER}/msg/connections/telegram/verify/${verificationCode}`,
        {},
        {withCredentials: true}));
  },

  resetConnectionVerification: async (connectionId) => {
    return handleResponse(
      axios.post(
        `${SERVER}/msg/connections/${connectionId}/reset-verification`,
        {},
        {withCredentials: true}));
  },

  deleteConnection: async (connectionId) => {
    return handleResponse(
      axios.delete(
        `${SERVER}/msg/connections/${connectionId}`,
        {withCredentials: true}));
  },


}

async function handleResponse (req) {
  let res;
  try {
    res = await req;
    if (res.status === 401) {
      return router.redirect('login');
    }
    return {res: res.data};
  } catch (err) {
    return {err};
  }
}
